import React,{useContext} from "react";
import a23logo from "../assets/a23_avatar_logo.png";
import closeIcon from '../assets/close.png'
import detailArrow from '../assets/revamp-assets/detailArrow.png'
import { connect } from "react-redux";
import Lottie from 'lottie-react'
// import notifyAnim from "../assets/NotifyAnim.json"
// import notifyAnim from "../assets/Bell-white.json"
import notifyAnim from "../assets/Bell.json"
import viewAllIcon from "../assets/ViewAllIcon.svg"
import { toggleModalAction } from '../redux/actions/userAction'
import { getNewBanners, getNewBonus } from "../Services/userService";
import giftBox from '../assets/revamp-assets/giftbox.png'
import hornIcon from '../assets/revamp-assets/promotion.png'
import foryou from '../assets/revamp-assets/foryou.png'
// import navarrow from "../assets/back_btn.png";
import Loading from "../models/Loading";

import { UserContext } from "../OEMChanges/OemAssetsImport";
import { WebToNativeMessage } from "../Common/Utils";
// import TitleIcon from "../assets/offerTag.png";
// import TitleIcon from "../assets/a23bonussummary/titleIcon.png";
// import RecommendedTag from "../assets/a23bonussummary/recommendedTag.png"//recTag.png
import TitleIcon from "../assets/offerSVG.svg";
import offersLeftFrameIcon from "../assets/offersLeftFrameIcon.svg"
// import bonusPercentIcon from "../assets/bonusPercentIcon.svg"
// import TimerIcon from "../assets/TimerIcon.svg"
// import RecommendedTag from "../assets/RecommendedSVG.svg";


class ActiveOffers extends React.Component {
    constructor(props) {
        super(props);
        console.log(this.props.assetChanges, " is assetChanges");
        if (sessionStorage.getItem("channel") === "OEMAPS1") {
            import('../Wallet/WalletInfoOEM.css');
            import('./SB2StyleOEM.css');
        } else {
            import('../Wallet/WalletInfo.css');
            import( './SB2Style.css');
        }
        this.state = {
            isBonusLoading: true,
            isBannerLoading: true,
            token: "",
            channel: "",
            _id: "",
            errors: {
                message: ""
            },
            username: "",
            maxBonusValue: "",
            aceLevel: "",
            newBonusSummaryData: { listOfBonus: [] },
            newBanners: { promotionalBanners: [] },
            userid: "",
            wagerRatio: 0,
            wagerReleaseRatio: 0,
            currentBonus: [],
            levelDetails: [],
            bonusInfoStatus: false,
            PPRBonusInfoStatus: false,
            enableHeader: 'Y',
            listOfBonus: [],
            PRBonus: [],
            CTBannerData: [],
            allBanners: [],
            everLasting: "N",
            expiryStatus: "",
            remainingTime: "",
        };
    }
    getExpiryStatusInfo = (listOfBonus) => {
        console.log("came into getExpiryStatusInfo", listOfBonus.expiryDate)
        let currentDate = new Date()
        let endDate = new Date(listOfBonus.expiryDate * 1000);
        console.log("endDate>>", endDate)
        console.log("result>>", endDate.getDate() + '/' + endDate.getMonth() + '/' + endDate.getFullYear());
        let totalSeconds = (endDate.getTime() - currentDate.getTime()) / 1000;
        let timeR

        let days = Math.floor(totalSeconds / (3600 * 24));
        let hours = Math.floor(totalSeconds % (3600 * 24) / 3600);
        let minutes = Math.floor(totalSeconds % 3600 / 60) + 1;

        console.log("days123>>", days)
        if (days <= 0) {
            timeR = hours > 0 ? hours + "h" + " " + minutes + "m" : minutes + "m"
            console.log("expiresin", timeR)
            // this.setState({
            //     remainingTime: timeR
            // })
            return ["expiresin", timeR]
        }
        else if (days > 0) {
            let month = endDate.getMonth() + 1
            let date = endDate.getDate()
            let year = endDate.getFullYear()
            if (date < 10) {
                date = "0" + date
            }
            if (month < 10) {
                month = "0" + month
            }
            timeR = date + '/' + month + '/' + year
            console.log("expireson", timeR)
            // this.setState({
            //     remainingTime: timeR
            // })
            return ["expireson", timeR]
        }

    }

    getActiveOffersDataInWallet = async () => {
        try {
            // console.log("AO TRY BLOCK")
            this.setState({
                token: window.sessionStorage["token"],
                a23token: window.sessionStorage["a23token"],
                channel: window.sessionStorage["channel"],
                _id: window.sessionStorage["userid"]
            })
            // console.log("AO TRY BLOCK 2")
            if (window.sessionStorage["CTBannerData"] && window.sessionStorage["CTBannerData"] !== undefined) {
                this.setState({
                    CTBannerData: JSON.parse(window.sessionStorage["CTBannerData"])
                })
            }
            // console.log("AO TRY BLOCK 3")
            await getNewBonus(window.sessionStorage['token'], window.sessionStorage['channel']).then((res) => {
                console.log("THIS IS THE NEW API THAT IS WORKING: ", res)
                this.setState({
                    newBonusSummaryData: res.data,
                    listOfBonus: res.data.listOfBonus.filter((bonus) => this.verifyExpiry(bonus) === false),
                    PRBonus: res.data.purhcasePRbonus ? res.data.purhcasePRbonus : [],
                    isBonusLoading: false,
                })
                let arr = [{
                    bonusCategory: "PROMO", bonusCode: "PROMOB4", bonusExpiryAt: "0 days", bonusPercent: "50", bonusType: "promo", expiryDate: "1690309800", hiddenBonusFlag: false, issuedOn: "1689744900",
                    levelDetails:
                        [
                            {
                                "minPurchase": "1",
                                "maxPurchase": "30000",
                                "bonusPercent": "50",
                                "instantBonusPercentage": "100",
                                "flatInstantBonus": "0",
                                "lockedBonusPercentage": "0",
                                "lockedBonusReleaseRatio": [
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1"
                                ]
                            }
                        ],
                    maxBonus: "15000",
                    minPurchase: "1",
                    minimum_first_purchase: 0,
                    validDays: "0",
                    welcomeBonus: false,
                    badge: "recommended"
                }, {
                    bonusCategory: "PROMO", bonusCode: "PROMOB4", bonusExpiryAt: "0 days", bonusPercent: "50", bonusType: "promo", expiryDate: "1690309800", hiddenBonusFlag: false, issuedOn: "1689744900",
                    levelDetails:
                        [
                            {
                                "minPurchase": "1",
                                "maxPurchase": "30000",
                                "bonusPercent": "50",
                                "instantBonusPercentage": "100",
                                "flatInstantBonus": "0",
                                "lockedBonusPercentage": "0",
                                "lockedBonusReleaseRatio": [
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1"
                                ]
                            }
                        ],
                    maxBonus: "15000",
                    minPurchase: "1",
                    minimum_first_purchase: 0,
                    validDays: "0",
                    welcomeBonus: false,
                    badge: "recommended"
                }, {
                    bonusCategory: "PROMO", bonusCode: "PROMOB4", bonusExpiryAt: "0 days", bonusPercent: "50", bonusType: "promo", expiryDate: "1690309800", hiddenBonusFlag: false, issuedOn: "1689744900",
                    levelDetails:
                        [
                            {
                                "minPurchase": "1",
                                "maxPurchase": "30000",
                                "bonusPercent": "50",
                                "instantBonusPercentage": "100",
                                "flatInstantBonus": "0",
                                "lockedBonusPercentage": "0",
                                "lockedBonusReleaseRatio": [
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1"
                                ]
                            }
                        ],
                    maxBonus: "15000",
                    minPurchase: "1",
                    minimum_first_purchase: 0,
                    validDays: "0",
                    welcomeBonus: false,
                    badge: "recommended"
                },
                {
                    bonusCategory: "PROMO", bonusCode: "PROMOB4", bonusExpiryAt: "0 days", bonusPercent: "50", bonusType: "promo", expiryDate: "1690309800", hiddenBonusFlag: false, issuedOn: "1689744900",
                    levelDetails:
                        [
                            {
                                "minPurchase": "1",
                                "maxPurchase": "30000",
                                "bonusPercent": "50",
                                "instantBonusPercentage": "100",
                                "flatInstantBonus": "0",
                                "lockedBonusPercentage": "0",
                                "lockedBonusReleaseRatio": [
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1",
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1"
                                ]
                            }
                        ],
                    maxBonus: "15000",
                    minPurchase: "1",
                    minimum_first_purchase: 0,
                    validDays: "0",
                    welcomeBonus: false,
                    badge: "recommended"
                }];
                console.log("List of arr arr arr arrr dsfdsfdsf", arr);




                this.setState({
                    dummyTestBonus: arr
                })
                // console.log('LIST OF BONUSES: ', window.sessionStorage["totalBalance"] > this.state.listOfBonus[0].minPurchase)
                WebToNativeMessage({
                    type: "redeemCTEvent", eventName: "PF_C_RTN_offerspageview", eventProperties: {
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        userId: window.sessionStorage["userid"],
                        username: window.sessionStorage["screenName"],
                        wallet_balance: window.sessionStorage["totalBalance"],
                        Click_timestamp: new Date().toLocaleTimeString(),
                        bonusAvailability: this.state.listOfBonus.length > 0,
                        bonus_code_1: this.state.listOfBonus[0] !== undefined ? window.sessionStorage["totalBalance"] > this.state.listOfBonus[0].minPurchase : 'NA',
                        bonus_code_2: this.state.listOfBonus[1] !== undefined ? window.sessionStorage["totalBalance"] > this.state.listOfBonus[1].minPurchase : 'NA',
                        bonus_code_3: this.state.listOfBonus[2] !== undefined ? window.sessionStorage["totalBalance"] > this.state.listOfBonus[2].minPurchase : 'NA',
                    }
                })
            })
            // console.log("AO TRY BLOCK 4")
            await getNewBanners(window.sessionStorage['a23token']).then((res) => {
                // console.log('NEW BANNER DATA IS: ', res.data)
                if (window.sessionStorage["CTBannerData"] && window.sessionStorage["CTBannerData"] !== undefined) {
                    this.setState({
                        newBanners: res.data,
                        allBanners: JSON.parse(window.sessionStorage["CTBannerData"])
                            .filter((banner) => banner.imageUrl !== undefined)
                            .sort((a, b) => a.order - b.order)
                            .concat(res.data.promotionalBanners
                                .filter((banner) => banner.active === true)
                                .sort((a, b) => a.order - b.order)),
                        isBannerLoading: false,
                    })
                    // console.log('All Sorted Banners: ', this.state.CTBannerData.filter((banner) => banner.imageUrl !== undefined).sort((a, b) => a.order - b.order))
                } else {
                    this.setState({
                        newBanners: res.data,
                        isBannerLoading: false,
                    })
                }
            })
            // console.log("AO TRY BLOCK 5")
            var screenValue = "";
            if (window.sessionStorage["channel"] == "A23APS" || window.sessionStorage["channel"] == "A23IPS") {
                screenValue = "P_BonusSummary";
            } else if (window.sessionStorage["channel"] == "FAPS" || window.sessionStorage["channel"] == "FIPS") {
                screenValue = "FS_P_BonusSummary";
            } else {
                screenValue = "R_BonusSummary"
            }
            if (window.sessionStorage !== undefined) {
                WebToNativeMessage({ type: "screenNameEvent", screenName: screenValue })
            }
        } catch (err) {
            // console.log("Error in getActiveOffersInWallet")
        }
    }

    verifyExpiry = (bonus) => {
        if ((bonus.expiryDate * 1000) > Date.now()) {
            //Not yet Expired
            return false
        } else {
            // Expired Condition
            return true
        }
    }

    async componentWillMount() {
        this.getActiveOffersDataInWallet()
        const searchParams = new URLSearchParams(this.props.location.search).get("enableHeader")
        this.setState({
            enableHeader: searchParams
        })
        window.sessionStorage.setItem("enableHeader", searchParams)
    }

    async componentDidMount() {
        // console.log("ACTIVE OFFERS MOUNTED")

        // console.log(contextType, " is contextType");
    }

    navigateToBonusSummary = () => {
        window.sessionStorage.setItem("isfrom", "activeoffers")
        this.props.history.push('/bonussummary/');
        // WebToNativeMessage({ type: "bonussummary" })
        // WebToNativeMessage({ type: "closeClient" })

    }
    enableClickHandler = () => {
        WebToNativeMessage({ "type": "OpenNotificationPermission" })
    }

    handleBannerClick = (CTMessage, deepLink) => {
        WebToNativeMessage(CTMessage)
        WebToNativeMessage(deepLink)
    }

    handleBackBtnClick = (msg) => {
        WebToNativeMessage(msg)
        window.sessionStorage["CTBannerData"] = "";
    }

    handleBonusDetailsPopup = (bonusData) => {
        let insdf = [{
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        },]
        this.setState({ currentBonus: bonusData })
        this.setState({ levelDetails: bonusData.levelDetails })
        // this.setState({ levelDetails: insdf })
        this.setState({ bonusInfoStatus: true })
        this.setState({ maxBonusValue: bonusData.maxBonus })
        document.body.style.overflow = "hidden"
    }

    getDateSuffix = (num) => {
        const nth = function (d) {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        }
        let suffix = nth(num)
        return suffix
    }

    handlePPRBonusDetailsPopup = (bonusData) => {
        this.setState({ currentBonus: bonusData })
        this.setState({ PPRBonusInfoStatus: true })
        document.body.style.overflow = "hidden"
    }

    getInstantLockedBonusData = (bonusData, isLocked) => {
        const maxPurchase = bonusData.maxPurchase
        const totalBonusPercentage = bonusData.bonusPercent
        var maxValueBonus = (maxPurchase / 100) * totalBonusPercentage

        var maxBonusAmt = 0
        if (this.state.maxBonusValue && this.state.maxBonusValue !== "") {
            maxBonusAmt = parseFloat(this.state.maxBonusValue)
        }

        let instantCash = 0;
        // var instantCash = parseInt(bonusData.flatInstantBonus)

        if (bonusData !== null && bonusData.flatInstantBonus !== null && bonusData.flatInstantBonus !== "") {
            instantCash = parseInt(bonusData.flatInstantBonus);
        }
        if ((maxBonusAmt - instantCash) < maxValueBonus) {
            maxValueBonus = maxBonusAmt - instantCash
        }



        let lockedValue = parseInt((maxValueBonus / 100) * parseInt(bonusData.lockedBonusPercentage));
        var locked = parseInt(lockedValue)
        var instantBonus = parseFloat(bonusData.instantBonusPercentage) * parseFloat(maxValueBonus / 100)

        if (locked > maxBonusAmt) {
            locked = maxBonusAmt - instantCash
        }

        const instantBonusVal = instantBonus + instantCash

        if (isLocked === true) {
            return locked
        } else {
            return instantBonusVal
        }
    }

    render() {
        let pushNotificationEnable = window.sessionStorage["pushNotificationEnable"]
        const assetChanges = this.context;
        console.log(assetChanges, " is assetChanges in render");
        return (
            <>
                {(this.state.isBonusLoading) ?
                    <div style={{ position: 'absolute', display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
                        <Loading />
                    </div>
                    :
                    <div style={{ position: 'sticky', top: '0', minWidth: '100vw', height: "100vh" }}>
                        <div className={(this.state.bonusInfoStatus || this.state.PPRBonusInfoStatus) ? 'maskedWallet' : ''}>
                            {/* If Enable Header === Y in URL params, we should render navbar. */}
                            {this.state.enableHeader === 'Y' ?
                                <nav className='navbar'>
                                    <div className="nav-container" >
                                        <img
                                            className='backBtn'
                                            src={assetChanges?.assets?.navarrow}
                                            style={{ width: "40px" }}
                                            onClick={() => this.handleBackBtnClick({ type: "closeClient" })}
                                        />
                                        {/* <p className="nav-text" style={{ textAlign: 'center' }}>My Offers</p> */}
                                        <p className="nav-text" style={{ textAlign: 'center' }}>Offers</p>
                                        <div></div>
                                    </div>
                                </nav>
                                :
                                null
                            }
                            <div className="summaryBonusContainer innerSection">
                                {/* Top Blue Section */}
                                {/* <div className="bonusSummaryDetails">
                                    <div className="bonusSummaryHeader">
                                        <span className="titleStyle bonusSummaryTitle">Bonus Summary</span>
                                        <div onClick={() => this.navigateToBonusSummary()}><span className="viewDetailsLink">View Details</span></div>
                                    </div>
                                    <div className="bonusSummaryGrid">
                                        <div className="gridItem">
                                            <div className="issuedBonus">
                                                <span className="gridTitle">Issued</span> */}
                                {/* <span className="gridData issuedText">2000000000</span> */}
                                {/* <span className="gridData"><span className="rupeeSmall">&#8377;</span>{this.state.newBonusSummaryData.totalIssuedBonus && Math.ceil(Number(this.state.newBonusSummaryData.totalIssuedBonus))}</span>
                                            </div>
                                        </div>
                                        <div className="gridItem">
                                            <div className="expiredBonus">
                                                <span className="gridTitle">Unlocked</span> */}
                                {/* <span className="gridData issuedText">2000</span> */}
                                {/* <span className="gridData"><span className="rupeeSmall">&#8377;</span>{this.state.newBonusSummaryData.totalReleasedBonus && Math.ceil(Number(this.state.newBonusSummaryData.totalReleasedBonus))}</span>
                                            </div>

                                        </div>
                                        <div className="gridItem">
                                            <div className="expiredBonus">
                                                <span className="gridTitle">Expired</span> */}
                                {/* <span className="gridData issuedText">2000</span> */}
                                {/* <span className="gridData"><span className="rupeeSmall">&#8377;</span>{this.state.newBonusSummaryData.totalExpiredBonus && Math.ceil(Number(this.state.newBonusSummaryData.totalExpiredBonus))}</span>
                                            </div>
                                        </div>
                                        <div className="gridItem">
                                            <div className="lockedBonus">
                                                <span className="gridTitle">Locked</span> */}
                                {/* <span className="gridData lockedBonusText">2000</span> */}
                                {/* <span className="gridData lockedBonusText"><span className="rupeeSmall">&#8377;</span>{this.state.newBonusSummaryData.totalLockedBonus && Math.ceil(Number(this.state.newBonusSummaryData.totalLockedBonus))}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                {/* Top code is for header bonus details section */}
                                {/* {console.log("fhfnjkfkjnfjnfjndfkjndfkjnkjnkjngkjng",this.state.listOfBonus )} */}
                                {/* {(this.state.listOfBonus !== undefined && this.state.listOfBonus.length !== 0) || (this.state.PRBonus.length !== 0) ? */}
                                {/* Need to comment the below check and un comment the above check */}
                                {(this.state.listOfBonus !== undefined && this.state.listOfBonus.length !== 0) || (this.state.PRBonus.length !== 0) ?
                                    <div className="availableBonusContainer">
                                        {/* <span className="titleStyle">Available Bonuses</span> */}
                                        <div style={{ position: "", width: "100%", height: "5%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <span className="titleStyle">All Bonuses</span>
                                            {/* className="viewDetailsLink" */}
                                            <div className="BonusSummary" id="BonusSummary">
                                                <span style={{ position: "", right: "", textDecoration: "", fontSize: "0.75rem" }} onClick={() => this.navigateToBonusSummary()}>Summary</span>
                                            </div>

                                        </div>
                                        {/* className="bonusCardContainer" */}
                                        <div style={{ marginTop: "1rem", display: "flex", flexDirection: "column" }}>
                                            {this.state.PRBonus.map((bonus, index) => {
                                                // console.log("bonus data >>>>>>>>> 1", bonus);
                                                // console.log("bonus data >>>>>>>>> 2", index);
                                                if (index === 0) {
                                                    return (
                                                        // <div className="eachBonusCard">
                                                        //     <div className="eachBonusCardLeft">
                                                        //         {/* <img src={offersLeftFrameIcon}></img> */}
                                                        //         <div className="bonusCodeContentText">{bonus.bonusCode}</div>

                                                        //     </div>
                                                        //     <div className="eachBonusCardRight">
                                                        //         <div className="BonusDataTop">
                                                        //             {/* {(bonus.badge && bonus.badge === "recommended") ? <img src={RecommendedTag} style={{display: Object.keys(this.state.PRBonus).length > 0 ? "none" : "block", position:"absolute", marginTop:"-19px", marginLeft:"-10px"}}></img> : ""} */}
                                                        //             <div className="BonusWorthDetails">
                                                        //                 <div className="BonusWorthData">
                                                        //                     <div className="BonusWorthText">
                                                        //                         Bonus worth ₹{bonus.bonusWorthAmount ? bonus.bonusWorthAmount : ""}
                                                        //                     </div>
                                                        //                     <div className="minPurchaseText">
                                                        //                         on min purchase of ₹{bonus.minimum_first_purchase}
                                                        //                     </div>
                                                        //                 </div>
                                                        //                 <div className="BonusDetails" onClick={() => this.handlePPRBonusDetailsPopup(bonus)}>
                                                        //                     Details
                                                        //                 </div>
                                                        //             </div>
                                                        //             {bonus.maxLockedBonusAmount && bonus.maxLockedBonusAmount != 0 && <div className="LockedBonusData">
                                                        //                 <div style={{ "display": "flex" }}>
                                                        //                     <img src={bonusPercentIcon}></img>
                                                        //                 </div>
                                                        //                 <div className="lockedBonusText">Locked Bonus</div>
                                                        //                 <div className="UptoText">Up to {bonus.maxLockedBonusPercentage ? bonus.maxLockedBonusPercentage : ""}%</div>
                                                        //                 <div className="lockedBonusText">(Max. ₹{bonus.maxLockedBonusAmount ? bonus.maxLockedBonusAmount : ""})</div>
                                                        //             </div>}
                                                        //             {bonus.maxInstantBonus && bonus.maxInstantBonus != 0 && <div className="InstantBonusData">
                                                        //                 <div style={{ "display": "flex" }}>
                                                        //                     <img src={bonusPercentIcon}></img>
                                                        //                 </div>
                                                        //                 <div className="lockedBonusText">Instant Bonus</div>
                                                        //                 <div className="UptoText">Up to ₹{bonus.maxInstantBonus}</div>
                                                        //             </div>}
                                                        //         </div>
                                                        //         <div className="Dividerline"></div>
                                                        //         <div className="BonusDataDown">
                                                        //             {this.state.remainingTime === "" && this.getExpiryStatusInfo(bonus)[0] === "expiresin" ? <div className="expiresInContent">
                                                        //                 <div className="expiresInText">Expires in :</div>
                                                        //                 <div className="TimerIconDiv">
                                                        //                     <img src={TimerIcon}></img>
                                                        //                 </div>
                                                        //                 <div className="expiresInTimer">{this.getExpiryStatusInfo(bonus)[1]}</div>
                                                        //             </div> : <div className="expiresOnContent">
                                                        //                 <div>Expires on :</div>
                                                        //                 <div>{this.getExpiryStatusInfo(bonus)[1]}</div>
                                                        //             </div>}
                                                        //             <div onClick={() => WebToNativeMessage({ type: "openAddCash", token: window.sessionStorage["token"], from: "", "Bonus code": bonus.bonusCode })} className="AddCashButton">+ Cash</div>
                                                        //             {/* <div style={{ width: "50%", textAlign: "end" }}>
                                                        //                 <button onClick={() => WebToNativeMessage({ type: "openAddCash", token: window.sessionStorage["token"], from: "", "Bonus code": bonus.bonusCode })} className="addCashButton" style={{}}>+ Cash</button>
                                                        //             </div> */}
                                                        //         </div>
                                                        //     </div>
                                                        // </div>
                                                        <div className="bonusCard" key={bonus + index} style={{ position: 'relative' }}>
                                                            {/*   <img src={RecommendedTag} style={{position:'',marginTop:"-10%"}}></img> */}

                                                            <div className="bonusCardTitleSection">
                                                                {/* <div className="bonusTitle"> */}
                                                                {/* <span>Recommended Offer</span> */}
                                                                {/* <img style={{ width: '60px', position: 'absolute', top: '3px', left: '-5px' }} src={foryou}></img> */}
                                                                {/* </div> */}

                                                                <div className="bonusTitle" style={{ display: "flex", flexDirection: "row", whiteSpace: "nowrap", marginLeft: "10px", alignItems: "center" }}>

                                                                    <img src={TitleIcon} style={{ width: '15px', height: "15px" }}></img>
                                                                    <span style={{ marginLeft: "5px" }}>{bonus.bonusCode}</span>

                                                                </div>
                                                                <div className="bonusDetailsLink" style={{ whiteSpace: 'nowrap' }}>
                                                                    {/* <span onClick={() => this.handlePPRBonusDetailsPopup(bonus)}>Details</span> */}
                                                                    <span onClick={() => this.handlePPRBonusDetailsPopup(bonus)} style={{ color: "#ffffff" }}>View Details</span>
                                                                    {/* <img src={detailArrow} style={{ width: '5px', marginLeft: '3px' }}></img> */}
                                                                </div>
                                                            </div>

                                                            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', height: '100%', margin: "10px" }}>
                                                                <div className="bonusBody">
                                                                    {/* <span className="cardBodyText">Get Flat {bonus.instantBonusPercent}% Bonus <br></br> {'('}Max: &#8377;{bonus.bonusValue}{')'}</span>
                                                                    <br></br>
                                                                    <span className="tinyText">Valid till: {new Date(Number(bonus.bonusEndDate * 1000)).toLocaleDateString('en-GB')}</span> */}
                                                                    <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center" }}>
                                                                        <span className="cardBodyText" style={{ fontSize: "0.75rem", width: "50%" }}>Get Flat</span>
                                                                        {/* {console.log("Ever lasting >>>>>>>>",bonus.everLasting)} */}
                                                                        <span className="tinyText" style={{ color: "#c62828", width: "50%", textAlign: "end", display: bonus.everLasting === "Y" ? "none" : "block" }}>Valid till: {new Date(Number(bonus.bonusEndDate * 1000)).toLocaleDateString('en-GB')}</span>


                                                                        {/* <span className="tinyText">Valid till: {new Date(Number(bonus.expiryDate * 1000)).toLocaleDateString('en-GB')}</span> */}
                                                                    </div>
                                                                </div>
                                                                <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                                    {/* Bonus percent */}
                                                                    {console.log(">>>>>>>><<<<<<<<<<<<<< drgdfghfghgh", bonus)}
                                                                    {/* <span style={{ fontSize: "0.9rem", fontWeight: "bold", width: "50%" }}>{bonus.instantBonusPercent}% Bonus {'('}Max: &#8377;{bonus.bonusValue}{')'}</span> */}
                                                                    {(bonus.bonusPercent !== 0) ? <span style={{ fontSize: "0.9rem", fontWeight: "bold", width: "50%" }}>{bonus.instantBonusPercent}% Bonus {'('}Max: &#8377;{bonus.bonusValue}{')'}</span> : <span style={{ fontSize: "0.9rem", fontWeight: "bold", width: "50%" }}>Upto {bonus.bonusValue} Bonus {'('}Max: &#8377;{bonus.bonusValue}{')'}</span>}
                                                                    <div style={{ width: "50%", textAlign: "end" }}>
                                                                        <button onClick={() => WebToNativeMessage({ type: "openAddCash", token: window.sessionStorage["token"], from: "", "Bonus code": bonus.bonusCode })} className="addCashButton" style={{}}>+ Cash</button>
                                                                    </div>

                                                                </div>
                                                                {/* <button onClick={() => WebToNativeMessage({ type: "openAddCash", token: window.sessionStorage["token"], from: "", })} className="addCashButton">Add Cash</button> */}
                                                            </div>


                                                        </div>
                                                    )
                                                } else {
                                                    return null
                                                }
                                            })}
                                            {/* {console.log("What is the list of bonus >>>>>>>",this.state.dummyTestBonus)} */}
                                            {/* {console.log("What is the list of bonus >>>>>>>",this.state.dummyTestBonus)}
                                            {console.log("What is the list of bonus >>>>>>> 2 ",this.state.newBonusSummaryData.listOfBonus)}
                                            {console.log("What is the list of bonus >>>>>>> 3 ",this.state.listOfBonus)} */}
                                            {/* {console.log("What is the list of bonus >>>>>>> 3 ",this.state.newBonusSummaryData)} */}
                                            {this.state.newBonusSummaryData.listOfBonus &&
                                                this.state.listOfBonus.map((bonus, index) => {
                                                    {/* Need to comment the below check and un comment the above check */ }
                                                    {/* {this.state.dummyTestBonus &&  */ }
                                                    {/* this.state.dummyTestBonus.map((bonus, index) => {    */ }
                                                    {/* // console.log("Neee yenkama >>>>>>>>>",bonus.badge); */ }

                                                    return (
                                                        // <div className="bonusCard" key={bonus + index}>


                                                        //     <div className="bonusCardTitleSection">
                                                        //         <div style={{ backgroundColor: "", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start" }}>
                                                        //             {(bonus.badge && bonus.badge === "recommended") ? <img src={RecommendedTag} style={{ width: "85px", height: "20%", position: '', marginTop: "-20%", marginLeft: "10%", display: Object.keys(this.state.PRBonus).length > 0 ? "none" : "block" }}></img> : ""}
                                                        //             <div className="bonusTitle" style={{ display: "flex", flexDirection: "row", whiteSpace: "nowrap", marginLeft: "10px", alignItems: "center" }}>

                                                        //                 {/* <img src={foryou} style={{position:"absolute",top:"-8%"}}></img> */}
                                                        //                 <img src={TitleIcon} style={{ width: '15px', height: "15px" }}></img>
                                                        //                 <span style={{ marginLeft: "5px" }}>{bonus.bonusCode}</span>

                                                        //             </div>
                                                        //         </div>
                                                        //         <div className="bonusDetailsLink" style={{ whiteSpace: 'nowrap' }}>
                                                        //             <span onClick={() => this.handleBonusDetailsPopup(bonus)} style={{ color: "#ffffff" }}>View Details</span>
                                                        //             {/* <img src={detailArrow} style={{ width: '5px', marginLeft: '3px' }}></img> */}
                                                        //         </div>
                                                        //     </div>

                                                        //     <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', height: '100%', margin: "10px" }}>
                                                        //         <div className="bonusBody" style={{ width: "100%" }}>
                                                        //             {
                                                        //                 bonus.levelDetails[0].lockedBonusPercentage != 0 ?
                                                        //                     <>
                                                        //                         {/* <span className="cardBodyText">Get Flat {bonus.bonusPercent}% Bonus <br></br> {'('}Max: &#8377;{bonus.maxBonus}{')'}</span> */}
                                                        //                         <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center" }}>
                                                        //                             <span className="cardBodyText" style={{ fontSize: "0.75rem", width: "50%" }}>{bonus.bonusGetOrFlatText}</span>

                                                        //                             <span className="tinyText" style={{ color: "#c62828", width: "50%", textAlign: "end", display: bonus.everLasting === "Y" ? "none" : "block" }}>Valid till: {new Date(Number(bonus.expiryDate * 1000)).toLocaleDateString('en-GB')}</span>


                                                        //                             {/* <span className="tinyText">Valid till: {new Date(Number(bonus.expiryDate * 1000)).toLocaleDateString('en-GB')}</span> */}
                                                        //                         </div>

                                                        //                     </>
                                                        //                     :
                                                        //                     <>
                                                        //                         <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center" }}>
                                                        //                             <span className="cardBodyText" style={{ fontSize: "0.75rem", width: "50%" }}>Get upto</span>

                                                        //                             <span className="tinyText" style={{ color: "#c62828", width: "50%", textAlign: "end", display: bonus.everLasting === "Y" ? "none" : "block" }}>Valid till: {new Date(Number(bonus.expiryDate * 1000)).toLocaleDateString('en-GB')}</span>


                                                        //                             {/* <span className="tinyText">Valid till: {new Date(Number(bonus.expiryDate * 1000)).toLocaleDateString('en-GB')}</span> */}
                                                        //                         </div>

                                                        //                         {/* <span className="cardBodyText">Get upto &#8377;{bonus.maxBonus} Instant Bonus</span>
                                                        //                         <br></br>
                                                        //                         <span className="tinyText">Valid till: {new Date(Number(bonus.expiryDate * 1000)).toLocaleDateString('en-GB')}</span> */}
                                                        //                     </>
                                                        //             }
                                                        //         </div>
                                                        //         <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                        //             {console.log("Locked Bonus percentage >>>>>>>>", bonus)}
                                                        //             <span style={{ fontSize: "0.9rem", fontWeight: "bold", width: "50%" }}>{bonus.bonusText}</span>
                                                        //             {/* {bonus.levelDetails[0].lockedBonusPercentage !== 0 ?   <span style={{ fontSize: "0.9rem", fontWeight: "bold", width: "50%" }}>{bonus.bonu}{bonus.bonusPercent}% Bonus {'('}Max: &#8377;{bonus.maxBonus}{')'}</span> : <span style={{ fontSize: "0.9rem", fontWeight: "bold", width: "50%" }}>&#8377;{bonus.maxBonus} Instant Bonus</span>} */}
                                                        //             <div style={{ width: "50%", textAlign: "end" }}>
                                                        //                 <button onClick={() => WebToNativeMessage({ type: "openAddCash", token: window.sessionStorage["token"], from: "", "Bonus code": bonus.bonusCode })} className="addCashButton" style={{}}>+ Cash</button>
                                                        //             </div>

                                                        //         </div>

                                                        //     </div>
                                                        // </div>
                                                        <div className="eachBonusCard" id="BonusCard">
                                                            <div className="eachBonusCardLeft">
                                                                {/* <img src={offersLeftFrameIcon}></img> */}
                                                                <div className="bonusCodeContentText">{bonus.bonusCode}</div>

                                                            </div>
                                                            <div className="eachBonusCardRight">
                                                                <div className="BonusDataTop">
                                                                    {(bonus.badge && bonus.badge === "recommended") ? <img src={assetChanges?.assets?.RecommendedTag} style={{ display: Object.keys(this.state.PRBonus).length > 0 ? "none" : "block", position: "absolute", marginTop: "-20px", marginLeft: "-10px" }}></img> : ""}
                                                                    <div className="BonusWorthDetails">
                                                                        <div className="BonusWorthData">
                                                                            <div className="BonusWorthText">
                                                                                Bonus worth ₹{bonus.bonusWorthAmount ? bonus.bonusWorthAmount : ""}
                                                                            </div>
                                                                            <div className="minPurchaseText">
                                                                                on min purchase of ₹{bonus.minimum_first_purchase}
                                                                            </div>
                                                                        </div>
                                                                        <div className="BonusDetails" id="BonusDetails" onClick={() => this.handleBonusDetailsPopup(bonus)}>
                                                                            Details
                                                                        </div>
                                                                    </div>
                                                                    {(bonus.maxLockedBonusAmount && bonus.maxLockedBonusAmount != 0) ? <div className="LockedBonusData">
                                                                        <div style={{ "display": "flex" }}>
                                                                            <img src={assetChanges?.assets?.bonusPercentIcon}></img>
                                                                        </div>
                                                                        <div className="lockedBonusText">Locked Bonus</div>
                                                                        <div className="UptoText">Up to {bonus.maxLockedBonusPercentage ? bonus.maxLockedBonusPercentage : ""}%</div>
                                                                        <div className="lockedBonusText">(Max. ₹{bonus.maxLockedBonusAmount ? bonus.maxLockedBonusAmount : ""})</div>
                                                                    </div> : ""}
                                                                    {(bonus.maxInstantBonus && bonus.maxInstantBonus != 0) ? <div className="InstantBonusData">
                                                                        <div style={{ "display": "flex" }}>
                                                                            <img src={assetChanges?.assets?.bonusPercentIcon}></img>
                                                                        </div>
                                                                        <div className="lockedBonusText">Instant Bonus</div>
                                                                        <div className="UptoText">Up to ₹{bonus.maxInstantBonus}</div>
                                                                    </div> : ""}
                                                                </div>
                                                                <div className="Dividerline"></div>
                                                                <div className="BonusDataDown">
                                                                    {this.state.remainingTime === "" && this.getExpiryStatusInfo(bonus)[0] === "expiresin" ? <div className="expiresInContent">
                                                                        <div className="expiresInText">Expires in :</div>
                                                                        <div className="TimerIconDiv">
                                                                            <img src={assetChanges?.assets?.DepositTimerIcon}></img>
                                                                        </div>
                                                                        <div className="expiresInTimer">{this.getExpiryStatusInfo(bonus)[1]}</div>
                                                                    </div> : <div className="expiresOnContent">
                                                                        <div>Expires on :</div>
                                                                        <div>{this.getExpiryStatusInfo(bonus)[1]}</div>
                                                                    </div>}
                                                                    <div onClick={() => WebToNativeMessage({ type: "openAddCash", token: window.sessionStorage["token"], from: "", "Bonus code": bonus.bonusCode })} className="AddCashButton" id="AddCashButton">+ Cash</div>
                                                                    {/* <div style={{ width: "50%", textAlign: "end" }}>
                                                                        <button onClick={() => WebToNativeMessage({ type: "openAddCash", token: window.sessionStorage["token"], from: "", "Bonus code": bonus.bonusCode })} className="addCashButton" style={{}}>+ Cash</button>
                                                                    </div> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                )
                                            }
                                        </div>
                                    </div>
                                    :
                                    <>
                                        {/* {pushNotificationEnable} */}
                                        {(pushNotificationEnable === false || pushNotificationEnable === "false") ?
                                            <div className="availableBonusContainer">
                                                {/* <span className="titleStyle">Available Bonuses</span> */}
                                                {/* <div style={{ position: "", width: "100%", height: "5%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                                        <span className="titleStyle">All Bonuses1</span>
                                        <span id="BonusSummary" style={{ position: "absolute", right: "2%", color: "#032146", textDecoration: "underline", fontSize: "0.75rem" }} onClick={() => this.navigateToBonusSummary()}>Summary</span>
                                    </div> */}
                                                <div className="HeaderContent">
                                                    <div className="ExpiredBonusDivContent">
                                                        <div className="ExpiredBonusText">All Bonuses</div>
                                                        <div className="ViewallDiv" onClick={() => this.navigateToBonusSummary()}>Summary

                                                            {/* <div>Summary</div> */}
                                                            {/* <div>
                                                    <img style={{ "marginLeft": "4px" }} src={viewAllIcon}></img>
                                                </div> */}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="noAvailableBonusesSection" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <Lottie style={{ "width": "90px", "height": "90px" }}
                                                        animationData={notifyAnim}
                                                        autoPlay={true}
                                                        loop={true}
                                                    />
                                                    <div style={{ marginTop: '1.5rem', color: '#032146', textAlign: 'center', fontSize: "14px", fontWeight: "700" }}>Don't miss out on rewards</div>
                                                    <div style={{ marginTop: '0.85rem', color: '#032146', textAlign: 'center', fontSize: "14px", }}>Enable notifications and get updates on offers specially for you.</div>
                                                    <div className="enableButton" onClick={() => this.enableClickHandler()}>Enable</div>
                                                </div>

                                                {/* <div className="footerContent">
                                        <div className="ExpiredBonusDiv">
                                            <div className="ExpiredBonusText">Expired Bonuses</div>
                                            <div className="ViewallDiv" onClick={() => this.navigateToBonusSummary()}>

                                                <div>View All</div>
                                                <div>
                                                    <img style={{ "marginLeft": "4px" }} src={viewAllIcon}></img>
                                                </div>

                                            </div>
                                        </div>
                                    </div> */}
                                            </div>
                                            :
                                            <div className="availableBonusContainer">
                                                {/* <span className="titleStyle">Available Bonuses</span> */}
                                                {/* <div style={{ position: "", width: "100%", height: "5%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                                                    <span className="titleStyle">All Bonuses1</span>
                                                    <span id="BonusSummary" style={{ position: "absolute", right: "2%", color: "#032146", textDecoration: "underline", fontSize: "0.75rem" }} onClick={() => this.navigateToBonusSummary()}>Summary</span>
                                                </div> */}
                                                <div className="HeaderContent">
                                                    <div className="ExpiredBonusDivContent">
                                                        <div className="ExpiredBonusText">All Bonuses</div>
                                                        <div className="ViewallDiv" onClick={() => this.navigateToBonusSummary()}>Summary

                                                            {/* <div>Summary</div> */}
                                                            {/* <div>
                                                    <img style={{ "marginLeft": "4px" }} src={viewAllIcon}></img>
                                                </div> */}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="noAvailableBonusesSection" style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <img style={{ width: '50px' }} src={assetChanges?.assets?.giftBox}></img>
                                                    {/* <span style={{ marginTop: '1.5rem', color: '#032146', textAlign: 'center', letterSpacing: '-0.5px' }}>Watch this space for exciting bonuses</span> */}
                                                    <span className="noAvailableBonusSummaryspan">There are no active bonuses for you. We are working on giving you more bonus offers</span>
                                                </div>
                                            </div>
                                        }
                                    </>


                                }


                                {/* Need to remove the code and add  in seperate file and routing */}



                            </div>
                        </div>

                        <div className={this.state.bonusInfoStatus ? this.state.enableHeader === 'Y' ? "redeemableBalanceInfo1" : "redeemableBalanceInfo" : "noDisplay"} style={{ overflow: "" }}>
                            <div style={{ width: '50px', position: 'absolute', top: '-25px', left: '50%', transform: 'translate(-50%)' }}>
                                {/* <img style={{ width: '100%' }} src={a23logo}></img> */}
                            </div>
                            <div className="infoHeader">
                                <img src={assetChanges?.assets?.closeIcon} className="closeButton" onClick={() => { this.setState({ bonusInfoStatus: false }); document.body.style.overflow = "scroll" }}></img>
                            </div>
                            <div className="infoTitle">
                                <span>{this.state.currentBonus.bonusCode}</span>
                            </div>
                            <div className="infoTable">
                                <table className="myTable">
                                    <thead>
                                        <tr className="myRow">
                                            <th className="myTH bonusPopup">Add Cash<br></br>{'('}in Rs.{')'}</th>
                                            <th className="myTH bonusPopup">Bonus%</th>
                                            <th className="myTH bonusPopup">Max Bonus<br></br>{'('}in Rs.{')'}</th>
                                            {/* <th className="myTH bonusPopup">Locked Bonus Release Ratio</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* maxBonus */}


                                        {this.state.levelDetails.length !== 0 && this.state.levelDetails.map((level, index) => {
                                            { console.log("tadi >>>>>>>>>>>>>>>>>>> 1", this.state.maxBonusValue) }
                                            // {console.log("tadi >>>>>>>>>>>>>>>>>>> 2",level.bonusPercent)}
                                            // {console.log("tadi >>>>>>>>>>>>>>>>>>> 3",level.instantBonusPercentage)}
                                            { console.log("tadi >>>>>>>>>>>>>>>>>>> 4", level.instantBonusPercentage) }
                                            { console.log("tadi >>>>>>>>>>>>>>>>>>> 5", level.lockedBonusPercentage) }
                                            //  {level.flatInstantBonus}
                                            return (
                                                <tr className="myRow">
                                                    <td className="tableCell">{level.minPurchase} - {level.maxPurchase}</td>
                                                    <td className="tableCell">{level.bonusPercent === 0 ? "-" : level.bonusPercent}<br></br>
                                                        {/* {'(' + level.lockedBonusPercentage + '% Locked)'} */}
                                                        {/* <br></br> */}
                                                        {/* {'(' + level.instantBonusPercentage + '% Instant)'} */}
                                                    </td>
                                                    {/* <td className="tableCell">Locked: {((level.maxPurchase * (level.bonusPercent / 100)) > Number(this.state.maxBonusValue)) ? parseInt(Number(this.state.maxBonusValue) - Number(level.flatInstantBonus)) : parseInt(level.maxPurchase * (level.bonusPercent / 100))}   <br></br> Instant: { parseInt(level.maxPurchase * (level.instantBonusPercentage / 100))}</td> */}

                                                    {/* <td className="tableCell">Locked: {parseInt((((level.maxPurchase*level.bonusPercent)/100)*level.lockedBonusPercentage)/100)}  
                                                    <br></br> Instant: {parseInt((((level.maxPurchase*level.bonusPercent)/100)*level.instantBonusPercentage)/100) + parseInt(level.flatInstantBonus)}</td> */}

                                                    {(this.state.currentBonus.welcomeBonus === true && this.state.currentBonus.bonusPercent === 0) ? <td className="tableCell"> {parseInt(this.getInstantLockedBonusData(level, false))}</td>
                                                        : <td className="tableCell">Locked: {parseInt(this.getInstantLockedBonusData(level, true))}
                                                            <br></br> Instant: {parseInt(this.getInstantLockedBonusData(level, false))}</td>}
                                                    {/* <td className="tableCell">{level.lockedBonusReleaseRatio.map((item, index) => {
                                                        return (
                                                            <div key={index + 'lbrt'}>
                                                                {item}<br></br>
                                                            </div>
                                                        )
                                                    })}</td> */}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <ul className="myUL">
                                {/* <li className="myLI">Bonus will expire within {this.state.currentBonus.validDays} days from issue date</li> */}
                                {/* <li className="myLI">Bonus will expire within {this.state.currentBonus.bonusExpiryAt} days from issue date</li> */}
                                {/* <li className="myLI">Bonus code is valid till {new Date(Number(this.state.currentBonus.expiryDate * 1000)).toLocaleDateString('en-GB')}, {new Date(Number(this.state.currentBonus.expiryDate * 1000)).toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric', hour12: true })}</li> */}
                                {/* <li className="myLI">For details regarding locked bonus, visit 'Menu'  {'>'}  'Promotions'  {'>'}  'Bonus Summary'</li> */}
                                {/* <li className="myLI">Bonus release criteria depends as per Ace Level</li> */}
                                {/* <li className="myLI">A23 Games T{'&'}C Apply</li> */}
                                <li className="myLI">Bonus code is valid till {new Date(Number(this.state.currentBonus.expiryDate * 1000)).toLocaleDateString('en-GB')}, {new Date(Number(this.state.currentBonus.expiryDate * 1000)).toLocaleTimeString('en-AU', { hour: 'numeric', minute: 'numeric', hour12: true, hourCycle: 'h12' })}</li>
                                {
                                    parseInt(this.state.currentBonus.maxLockedBonusPercentage) > 0 && (
                                        (sessionStorage.getItem("channel") === "IPAPS" || sessionStorage.getItem("channel") === "IPIPS") ?
                                            <li className="myLI">The rake to release ratio varies with Game-wise </li>
                                            :
                                            <li className="myLI">The wager to release ratio varies with Game-wise </li>
                                    )
                                }
                                {console.log("level details >>>>>>>", this.state.levelDetails[0])}
                                {/* //&& this.state.levelDetails.map((level, index) => { */}


                                {parseInt(this.state.currentBonus.maxLockedBonusPercentage) > 0 && this.state.levelDetails[0] &&
                                    <div id="row3" className="tableCell">{this.state.levelDetails[0].lockedBonusReleaseRatio.map((item, index) => {
                                        return (
                                            <div key={index + 'lbrt' + Math.random() * 2} style={{ display: "flex", width: "100%", backgroundColor: "", justifyContent: "center", alignItems: "center" }}>
                                                {item}<br></br>
                                            </div>
                                        )
                                    }
                                    )
                                    }</div>
                                }

                                {/* <div   className="tableCell" style={{maxHeight:"40px",overflow:"scroll"}}>{this.state.levelDetails[0].lockedBonusReleaseRatio.map((item, index) => {
                                                        return (
                                                            <div key={index + 'lbrt'+Math.random()*2}>
                                                                {item}<br></br>
                                                            </div>
                                                        )
                                                    }
                                                    )
                                                    }</div> */}



                                {/* {
                                this.state.levelDetails.lockedBonusReleaseRatio.map((item, index) => {
                                                        return (
                                                            <div key={index + 'lbrt'}>
                                                                {item}<br></br>
                                                            </div>
                                                        )
                                                    })
                                                    
                                                    
                                                    } */}


                                {parseInt(this.state.currentBonus.maxLockedBonusPercentage) > 0 && <li className="myLI">Locked bonus can be unlocked with in {this.state.currentBonus.bonusExpiryAt} from issue date {this.state.currentBonus?.redeemRemainingToExpire > 0 && ` or until ${this.state.currentBonus?.redeemRemainingToExpire === 1 ? 'Next' : this.state.currentBonus?.redeemRemainingToExpire}${this.state.currentBonus?.redeemRemainingToExpire > 1 ? this.getDateSuffix(this.state.currentBonus?.redeemRemainingToExpire) : ''} withdraw`}</li>}
                                {/* <li className="myLI">For details regarding locked bonus, visit 'Menu'  {'>'}  'Promotions'  {'>'}  'Bonus Summary'</li> */}
                                {parseInt(this.state.currentBonus.maxLockedBonusPercentage) > 0 && <li className="myLI">Released bonus added to the wallet in chunks as per your acelevel</li>}
                                <li className="myLI">A23 Games T{'&'}C Apply</li>
                            </ul>
                        </div>
                        {console.log("This state >>>>>>>>>>>>>>>> ???????", this.state.currentBonus)}
                        <div className={this.state.PPRBonusInfoStatus ? "redeemableBalanceInfo" : "noDisplay"}>
                            <div style={{ width: '50px', position: 'absolute', top: '-25px', left: '50%', transform: 'translate(-50%)' }}>
                                <img style={{ width: '100%' }} src={a23logo}></img>
                            </div>
                            <div className="infoHeader">
                                <img src={assetChanges?.assets?.closeIcon} className="closeButton" onClick={() => { this.setState({ PPRBonusInfoStatus: false }); document.body.style.overflow = "scroll" }}></img>
                            </div>
                            <div className="infoTitle">
                                <span>{this.state.currentBonus.bonusCode} Bonus Details</span>
                            </div>
                            <div className="infoTable">
                                <table className="myTable">
                                    <thead>
                                        <tr className="myRow">
                                            {/* <th className="myTH bonusPopup">Add Cash<br></br>{'('}in Rs.{')'}</th> */}
                                            <th className="myTH bonusPopup">Bonus%</th>
                                            <th className="myTH bonusPopup">Max Bonus<br></br>{'('}in Rs.{')'}</th>
                                            <th className="myTH bonusPopup">Locked Bonus Release Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="myRow">
                                            <td className="tableCell">{this.state.currentBonus.instantBonusPercent}</td>
                                            <td className="tableCell">{this.state.currentBonus.bonusValue}</td>
                                            {(this.state.currentBonus.wagerReleaseRatio !== undefined) &&
                                                Object.keys(this.state.currentBonus.wagerReleaseRatio).length !== 0 ?
                                                <div key={Math.random() * 4} className="tableCell" style={{ maxHeight: "40px", overflow: "scroll" }}>{Object.keys(this.state.currentBonus.wagerReleaseRatio).map((key, index) => {
                                                    return (
                                                        <div id="row1" key={index + 'lbrt'} style={{ textTransform: 'capitalize' }}>
                                                            {key + " : " + this.state.currentBonus.wagerReleaseRatio[key].wagerRatio + ":" + this.state.currentBonus.wagerReleaseRatio[key].wagerReleaseRatio}<br></br>
                                                        </div>
                                                    )
                                                })}</div>
                                                :
                                                null
                                            }
                                        </tr>
                                    </tbody>
                                </table>
                                {/* <ul className="myUL">
                                    <li className="myLI">Bonus will expire within {this.state.currentBonus.claimValidity} days from issue date</li>
                                    <li className="myLI">Bonus code is valid till {new Date(Number(this.state.currentBonus.bonusEndDate * 1000)).toLocaleDateString('en-GB')}, {new Date(Number(this.state.currentBonus.bonusEndDate * 1000)).toLocaleTimeString('en-AU', { hour: 'numeric', minute: 'numeric', hour12: true })}</li>
                                    <li className="myLI">Bonus release criteria depends as per Ace Level</li>
                                    <li className="myLI">A23 Games T{'&'}C Apply</li>
                                </ul> */}
                                <ul className="myUL">
                                    {/* <li className="myLI">Bonus will expire within {this.state.currentBonus.validDays} days from issue date</li> */}
                                    {/* <li className="myLI">Bonus will expire within {this.state.currentBonus.bonusExpiryAt} days from issue date</li> */}
                                    {/* <li className="myLI">Bonus code is valid till {new Date(Number(this.state.currentBonus.expiryDate * 1000)).toLocaleDateString('en-GB')}, {new Date(Number(this.state.currentBonus.expiryDate * 1000)).toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric', hour12: true })}</li> */}
                                    {/* <li className="myLI">For details regarding locked bonus, visit 'Menu'  {'>'}  'Promotions'  {'>'}  'Bonus Summary'</li> */}
                                    {/* <li className="myLI">Bonus release criteria depends as per Ace Level</li> */}
                                    {/* <li className="myLI">A23 Games T{'&'}C Apply</li> */}
                                    <li className="myLI">Bonus code is valid till {new Date(Number(this.state.currentBonus.bonusEndDate * 1000)).toLocaleDateString('en-GB')}, {new Date(Number(this.state.currentBonus.bonusEndDate * 1000)).toLocaleTimeString('en-AU', { hour: 'numeric', minute: 'numeric', hour12: true, hourCycle: 'h12' })}</li>
                                    <li className="myLI">The wager to release ratio varies with Game-wise </li>
                                    {(this.state.currentBonus.wagerReleaseRatio !== undefined) &&
                                        Object.keys(this.state.currentBonus.wagerReleaseRatio).length !== 0 ?
                                        <td className="tableCell">{Object.keys(this.state.currentBonus.wagerReleaseRatio).map((key, index) => {
                                            return (
                                                <div id="row2" key={index + 'lbrt'} style={{ textTransform: 'capitalize' }}>
                                                    {key + " : " + this.state.currentBonus.wagerReleaseRatio[key].wagerRatio + ":" + this.state.currentBonus.wagerReleaseRatio[key].wagerReleaseRatio}<br></br>
                                                </div>
                                            )
                                        })}</td>
                                        :
                                        null
                                    }
                                    {/* {
                                this.state.levelDetails.lockedBonusReleaseRatio.map((item, index) => {
                                                        return (
                                                            <div key={index + 'lbrt'}>
                                                                {item}<br></br>
                                                            </div>
                                                        )
                                                    })
                                                    
                                                    
                                                    } */}


                                    <li className="myLI">Locked bonus can be unlocked with in {this.state.currentBonus.bonusExpiryAt} days from issue date {this.state.currentBonus?.redeemRemainingToExpire > 0 && ` or until ${this.state.currentBonus?.redeemRemainingToExpire === 1 ? 'Next' : this.state.currentBonus?.redeemRemainingToExpire}${this.state.currentBonus?.redeemRemainingToExpire > 1 ? this.getDateSuffix(this.state.currentBonus?.redeemRemainingToExpire) : ''} withdraw`}</li>
                                    {/* <li className="myLI">For details regarding locked bonus, visit 'Menu'  {'>'}  'Promotions'  {'>'}  'Bonus Summary'</li> */}
                                    <li className="myLI">Released bonus added to the wallet in chunks as per your acelevel</li>
                                    <li className="myLI">A23 Games T{'&'}C Apply</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}
ActiveOffers.contextType = UserContext;
const mapStateToProps = state => ({
    userState: state.userState
});

export default connect(
    mapStateToProps,
    { toggleModalAction }
)(ActiveOffers);